import React from "react";
import { AColumn } from "src/components/tables/AsyncTable";
import { SorterResult } from "antd/es/table/interface";
import styles from "./TableSortingButtonSdt.module.less";
import defaultIcon from "./defaultIcon.svg";
import ascendIcon from "./ascendIcon.svg";
import descendIcon from "./descendIcon.svg";

type PropsTableSortingButtonSdt<TRow extends {}> = {
  header: React.ReactNode;
  column: AColumn<TRow>;
  onChange?: (sorter?: SorterResult<TRow>) => void;
};

export const TableSortingButtonSdt = <TRow extends {}>({
  header,
  column,
  onChange,
}: PropsTableSortingButtonSdt<TRow>) => {
  const { sorter, sortOrder } = column;
  let actualIcon = !!sorter && defaultIcon;
  if (sortOrder) {
    actualIcon = sortOrder === "ascend" ? ascendIcon : descendIcon;
  }

  const getNextOrder = () => {
    if (sortOrder === undefined) return "ascend";
    if (sortOrder === "ascend") return "descend";
    if (sortOrder === "descend") return undefined;
    return undefined;
  };

  const content = <div className={styles.content}>{header}</div>;

  return column.sorter ? (
    <button
      className={styles.sorter}
      type="button"
      onClick={() => {
        onChange?.({ column, columnKey: column.key, order: getNextOrder() });
      }}
    >
      {content}
      <img src={actualIcon} alt="" />
    </button>
  ) : (
    content
  );
};
